import { AsyncPipe } from '@angular/common'
import { Component, Input } from '@angular/core'
import { ClockWidget, ProjectCMSWidgetType } from 'htv-lib'
import moment from 'moment'
import { map, timer } from 'rxjs'

@Component({
  selector: 'app-editor-clock',
  standalone: true,
  imports: [AsyncPipe],
  templateUrl: './clock.component.html',
  styleUrls: ['./clock.component.scss'],
})
export class ClockComponent {
  @Input() config: ClockWidget = {
    type: ProjectCMSWidgetType.CLOCK,
    name: 'clock-digital',
    height: 40,
    width: 110,
    x: 1770,
    y: 20,
    fontSize: 30,
  }
  time$ = timer(0, 1000).pipe(map(() => moment().format('LT')))
}
